import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function OwnerInvoicesPage() {
  return (
    <SectionLayout title="Owner Invoices">
      {/* Owner invoices content will go here */}
    </SectionLayout>
  );
} 